import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-impact-card',
  templateUrl: './impact-card.component.html',
  styleUrls: ['./impact-card.component.css'],
})
export class ImpactCardComponent implements OnInit {
  @Input() influence: any;
  constructor() {}

  ngOnInit(): void {}
}
